import { Filter } from '@cubejs-client/core';

const parseHierarchicalFilterOldTree = (
  filterValue: string[],
  dimensions: string[],
  isWithAdditionalParam?: boolean,
  additionalParam?: string,
) => {
  const valuesPerDimension: { [key: string]: string[] } = {};
  const additionalValue = additionalParam ? additionalParam : 'N/A';

  filterValue.forEach(fullKey => {
    const splitKey = fullKey.split('__');
    const lastIndex = splitKey.length - 1;
    const dimension = dimensions[lastIndex];
    if (!valuesPerDimension[dimension]) valuesPerDimension[dimension] = [];
    valuesPerDimension[dimension].push(splitKey[lastIndex]);
  });

  const parentFilter: Filter = {
    or: [] as Filter[],
  };

  for (const dimension in valuesPerDimension) {
    const values = valuesPerDimension[dimension];
    if (values.length === 0) continue;

    const filter = {
      member: dimension,
      operator: 'equals',
      values: isWithAdditionalParam ? [...values, additionalValue] : values,
    } as Filter;
    parentFilter.or.push(filter);
  }

  if (parentFilter.or.length > 0) return parentFilter;
  return null;
};

export default parseHierarchicalFilterOldTree;
